<template>
    <div class="beijing">
        <!-- <img src="@/assets/images/denglu.png" alt="" style="width: 100%;"> -->
        <div class="login row">
            <div class="login_l column">
                <div class="login_l_m row">
                    <!-- <img src="@/assets/images/login_logo.png" alt=""> -->
                    <i class="el-icon-collection-tag" style="font-size: 42px; color: #999; "></i>
                    <div class="login_l_m_r column">
                        <!-- <div style="color: #00b277;font-weight: 600;">找工作</div>
                        <div style="color: #00b277;">上职远速聘直接谈</div> -->
                        <div style="color: #666;font-weight: 600;">找工作</div>
                        <div style="color: #999;">上职远速聘直接谈</div>
                    </div>
                </div>
                <div class="login_l_m row">
                    <i class="el-icon-chat-line-round" style="font-size: 42px; color: #999; "></i>
                    <div class="login_l_m_r column">
                        <div style="color: #666;font-weight: 600;">沟通</div>
                        <div style="color: #999;">在线职位及时沟通</div>
                    </div>
                </div>
                <div class="login_l_m row">
                    <i class="el-icon-suitcase" style="font-size: 42px; color: #999; "></i>
                    <div class="login_l_m_r column">
                        <div style="color: #666;font-weight: 600;">任性选</div>
                        <div style="color: #999;">各大行业职位任你选</div>
                    </div>
                </div>
            </div>
            <div class="login_r column">
                <div class="login_r_m column">
                    <div class="login_r_m_title">验证码登录/注册</div>
                    <div class="login_r_m_subtitle">首次验证通过即注册职远速聘账号</div>
                    <div class="login_r_m_m column">
                        <div class="login_r_m_m_tab row">
                            <div class="login_r_m_m_tab_l">我要找工作</div>
                            <div class="login_r_m_m_tab_r">
                                <a href="https://hr.zhiyuansupin.com/#/login"
                                    style="display: block; width: 180px; height: 40px;">我要招聘</a>
                            </div>
                        </div>
                        <div>
                            <el-input type="text" onkeyup="value=value.replace(/[^\d]/g,'')" v-model="shoujihao"
                                :maxlength="11" placeholder="手机号"></el-input>
                        </div>
                        <div style="margin-top: 20px;position: relative;">
                            <el-input v-model="yanzhengma" :maxlength="6" placeholder="验证码"></el-input>
                            <div class="login_r_m_m_yanzhengma" v-if="countdown == 0" @click="clickyanzhengma">发送验证码</div>
                            <div class="login_r_m_m_yanzhengma_huise" v-if="countdown > 0">{{ countdown + '秒后重新获取' }}</div>
                            <!-- 拼图滑块验证 -->
                            <Verify mode="pop" :captchaType="'blockPuzzle'" :imgSize="{ width: '400px', height: '200px' }"
                                ref="verifyRef" @success="onSuccBlockPuzzle" />
                        </div>
                        <div style="margin-top: 20px;">
                            <el-button class="login_r_m_m_button" :loading="loading" @click="clickdenglu">登录/注册</el-button>
                        </div>

                    </div>
                    <div class="login_r_m_bottom column">
                        <div class="login_r_m_bottom_top">
                            <el-checkbox v-model="yinsitongyi" style="margin-right: 5px;"></el-checkbox>
                            <span>已阅读并同意职远速聘
                                <a href="https://www.zhiyuansupin.com/contract/agreement.html" target="_blank"
                                    style="color: #00b277;">《用户协议》</a>
                                <a href="https://www.zhiyuansupin.com/contract/privacy.html" target="_blank"
                                    style="color: #00b277;">《隐私政策》</a>，允许职远速聘统一管理本人账号信息
                            </span>
                        </div>
                        <!-- <div class="login_r_m_bottom_text">客服电话 400-***-**** 工作时间：8:00-22:00</div> -->
                        <!-- <div class="login_r_m_bottom_text"><a @click="tiaozhuan('/permit')">人力资源服务许可证</a>
                            &nbsp;&nbsp;
                            <a @click="tiaozhuan('/license')">营业执照</a>
                        </div> -->
                        <div class="login_r_m_bottom_text">
                            <a href="https://img.zhiyuansupin.com/files/xukezheng.png" target="_blank">人力资源服务许可证</a>
                            &nbsp;
                            <a href="https://img.zhiyuansupin.com/files/yingyezhizhao.jpg" target="_blank">营业执照</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Verify from './verifition/Verify.vue';


export default {
    name: 'LaLogin',
    components: {
        Verify
    },
    data() {
        return {
            // shoujihao: '13852223593',
            // yanzhengma: '794342',
            shoujihao: '',
            yanzhengma: '',
            huakuai: '',
            hkqm: "",
            countdown: 0,
            loading: false,
            yinsitongyi: false,
        }
    },
    mounted() {

    },
    activated() {

    },
    methods: {
        // 获得验证
        onSuccBlockPuzzle(params) {
            console.log('获得验证-->', params.captchaVerification);
            if (params.captchaVerification) {
                this.hkqm = params.captchaVerification;
                // 获取验证码
                this.postSmsCode();
                // 启动倒计时
                this.startCountdown(60); // 假设倒计时60秒
            }
        },
        // 启动验证码倒计时
        startCountdown(seconds) {
            this.countdown = seconds;
            const intervalId = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown -= 1;
                } else {
                    clearInterval(intervalId);
                }
            }, 1000);
        },
        clickdenglu() {
            if (this.shoujihao) {
                if (this.yanzhengma) {
                    if (this.yinsitongyi) {
                        this.loading = true;
                        // this.$router.push('/index');
                        this.postPCLogin();
                    } else {
                        this.$message.error('请勾选用户协议！');
                    }
                } else {
                    this.$message.error('验证码不能为空！');
                }
            } else {
                this.$message.error('手机号不能为空！');
            }
        },
        // 获取验证码
        clickyanzhengma() {
            if (/^1[3-9]\d{9}$/.test(this.shoujihao)) {
                // console.log('获取验证码-->');
                // this.postSmsCode();
                // 显示滑动验证
                this.$refs.verifyRef.show();
            } else {
                this.$message.error('请填写正确手机号');
            }
        },
        // 获取验证码接口
        async postSmsCode() {
            try {
                let res = await this.$API.postSmsCodeApi({ mobile: this.shoujihao, captchaVerification: this.hkqm });
                console.log('获取验证码-->', res);
            } catch (error) {
                console.log('获取验证码error-->', error);
                this.$message.error(error);
            }
        },
        // 登录接口
        async postPCLogin() {
            try {
                let res = await this.$API.postPCLoginApi({ mobile: this.shoujihao, code: this.yanzhengma });
                console.log('登录接口-->', res);
                if (res.code == 0) {
                    this.$message.success('登录成功');
                    localStorage.setItem('Authorization', 'Bearer ' + res.data.accessToken)
                    let time = setInterval(() => {
                        if (localStorage.getItem('Authorization')) {
                            clearInterval(time)
                            this.$router.push('/');
                        }
                    }, 100);
                }
                if (res.code != 0) {
                    this.$message.error(res.message);
                }
                this.loading = false;
            } catch (error) {
                console.log('登录接口error-->', error);
                this.$message.error(error);
                this.loading = false;
            }
        },
        tiaozhuan(val) {
            this.$router.push(val);
        },
    }

}
</script>

<style scoped>
.beijing {
    min-height: 100vh;
    background: #00b277 url('@/assets/images/login_bg.png') bottom/100% auto no-repeat !important;
    position: relative;
}

.login {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 728px;
    height: 500px;
    margin-left: -364px;
    margin-top: -290px;
    background: #fff;
    box-shadow: 0 6px 13px 0 rgba(0, 0, 0, .1);
    border-radius: 28px;
    z-index: 2;
    box-sizing: border-box;
}

.login_l {
    float: left;
    width: 240px;
    height: 100%;
    background: linear-gradient(214deg, #dffbff, #faf6f3);
    border-radius: 28px 0 0 28px;
    padding-left: 32px;
    font-size: 14px;
    box-sizing: border-box;
}

.login_l_m {
    height: 42px;
    margin-top: 68px;
}

.login_l_m img {
    width: 42px;
    height: 42px;
}

.login_l_m_r {
    line-height: normal;
    height: 42px;
    margin-left: 12px;
    font-size: 14px;
    justify-content: space-between;
}

.login_r {
    width: 488px;
    padding: 48px 0;
}

.login_r_m {
    width: 360px;
    margin: 0 auto;
}

.login_r_m_title {
    font-size: 22px;
    font-weight: 500;
    color: #222;
    line-height: 30px;
    text-align: center;
}

.login_r_m_subtitle {
    color: #999;
    line-height: 17px;
    text-align: center;
    margin-top: 8px;
    font-size: 12px;
}

.login_r_m_m {
    margin-top: 12px;
}

.login_r_m_m_tab {
    width: 100%;
    margin-bottom: 20px;
    padding: 4px;
    background: #f8f8f8;
    border-radius: 12px;
}

.login_r_m_m_tab_l {
    font-weight: 500;
    color: #00b277;
    background: #fff;
    cursor: default;
    float: left;
    width: 50%;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    border-radius: 8px;
    transition: all .2s linear;
}

.login_r_m_m_tab_r {
    float: left;
    width: 50%;
    height: 40px;
    font-size: 16px;
    color: #444;
    line-height: 40px;
    text-align: center;
    border-radius: 8px;
    cursor: pointer;
}

.login_r_m_m_tab_r:hover {
    color: #00b277;
}

.login_r_m_m_yanzhengma {
    position: absolute;
    right: 5px;
    top: 1px;
    line-height: 38px;
    height: 38px;
    background-color: #fff;
    padding: 0 20px;
    color: #00b277;
    cursor: pointer;
    font-size: 16px;
}

.login_r_m_m_yanzhengma_huise {
    position: absolute;
    right: 5px;
    top: 1px;
    line-height: 38px;
    height: 38px;
    background-color: #fff;
    padding: 0 20px;
    color: #999999;
    font-size: 16px;
}

.login_r_m_m_button {
    width: 100%;
    color: #fff;
    background: #00b277;
    border: 1px solid #00b277;
    font-size: 16px;
    padding: 15px 0;
    border-radius: 4px;
}

.login_r_m_bottom {
    margin-top: 20px;
}

.login_r_m_bottom_top {
    margin-top: 20px;
    font-size: 12px;
    color: #666;
    line-height: 17px;
    text-align: center;
}

.login_r_m_bottom_text {
    margin-top: 20px;
    color: #8d92a1;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
}
</style>
